/**
 * Get theme color value by path (adapted from RN)
 * @param colors - Theme colors object
 * @param path - Dot-separated path like "label.default"
 * @returns Resolved color string or undefined
 */
export const getThemeColorValue = (
  colors: any,
  path: string,
): string | undefined => {
  return path
    .split('.')
    .reduce((acc, key) => (acc ? acc[key] : undefined), colors)
}
